<div class="row">
  <div class="col-4">
    <rask-textmultiline label="Åtgärdstyp">
      <span>{{atgard.atgardstypnamn}}</span>
        @if (isSkordarmatning()) {
            <rask-arbetsorder-warning-pill>
                ESM
            </rask-arbetsorder-warning-pill>
            }
      @if (atgard.extraordinarHandelse?.length > 0) {
        <div>
          <rask-arbetsorder-warning-pill class="extraordinar-handelse">
            EOH
          </rask-arbetsorder-warning-pill>
          <span>{{atgard.extraordinarHandelse}}</span>
        </div>
      }
    </rask-textmultiline>
  </div>
  <div class="col-4">
    <rask-textmultiline label="Ansvarig planerare" [value]="atgard.ansvarigPlanerare"></rask-textmultiline>
  </div>
  <div class="col-4">
    @if (relateradAtgard) {
      <div>
        <rask-textmultiline
          label="{{isRelateradAtgardGrot() ? 'Relaterad åtgärd Grot' : 'Relaterad åtgärd Rundvirke'}}">
          <a
            [routerLink]="['/planera', relateradAtgard.arbetsorderId]"
          [queryParams]="{atgardId: relateradAtgard.atgardId}">{{relateradAtgard.atgardBeteckning}}</a>
        </rask-textmultiline>
      </div>
    }
  </div>
</div>
<div class="row">
  <div class="col-4">
    <rask-textmultiline label="Planerat datum" value="{{ atgard.planeratDatum | date:'shortDate'}}">
    </rask-textmultiline>
  </div>
  <div class="col-4">
    <rask-textmultiline label="Planeringsstatus">
      <div>
        <rask-planeringsstatus-indicator
          [planeringsstatus]="arbetsorder.planeringsstatus">
        </rask-planeringsstatus-indicator>
        <span> {{atgard.planeringsstatus}}</span>
      </div>
    </rask-textmultiline>
  </div>
  <div class="col-4">
    @if (relateradAtgard && !isRelateradAtgardGrot()) {
      <rask-textmultiline label="Skördad"
        value="{{ relateradAtgard.arbetsorderSkordningAvslutadDatum | date:'shortDate'}}">
      </rask-textmultiline>
    }
    @if (existInNavetApp()) {
      <rask-textmultiline label="Länk till NavetApp"
        infoText="Länk till NavetApp kräver internt nätverk eller VPN">
        <a href="{{navetAppLink()}}" target="_blank">{{atgard.beteckning}}</a>
      </rask-textmultiline>
    }
  </div>
</div>
<div class="row">
  <div class="col-4">
    <rask-selector
      class="barighet"
      label="Skog"
      [values]="barigheter"
      [disabled]="!isArbetsorderTillganglig()"
      [ngModel]="atgard.tillganglighetMark"
      (ngModelChange)="updateAtgardBarighetMark($event)">
    </rask-selector>
  </div>
  <div class="col-4">
    <rask-selector
      class="barighet"
      label="Väg"
      [values]="barigheter"
      [disabled]="!isArbetsorderTillganglig()"
      [ngModel]="atgard.tillganglighetVag"
      (ngModelChange)="updateAtgardBarighetVag($event)">
    </rask-selector>
  </div>
  <div class="col-4">
    @if (arbetsorder.isGrotskotning && relateradAtgard) {
      <rask-textmultiline label="Skördad av"
      [value]="relateradAtgard.arbetsorderMaskinlagNamn"></rask-textmultiline>
    }
    @if (arbetsorder.isAvverkning) {
      <rask-textmultiline label="Medelstam"
      value="{{atgard.medelstam | raskDecimal: 2}}"></rask-textmultiline>
    }
  </div>
</div>
<div class="row">
  <div class="col-4">
    <rask-checkbox label="Kontakta planerare" [checked]="atgard.kontaktaPlaneraren" [disabled]="true"
    [ngModel]="atgard.kontaktaPlaneraren"></rask-checkbox>
  </div>
</div>
@if (arbetsorder.isAvverkning) {
  <div class="row">
    <div class="col-4">
      <rask-radiobutton-group
        class="pe-0"
        label="Grotanpassning"
        [disabled]="!canSetGrotanpassning()"
        [buttons]="[{key:true, value:'Ja'}, {key:false, value:'Nej'}]"
        [(ngModel)]="atgard.grotuttagProduktionsplanerat"
        (change)="modifyGrotuttagProduktionsplanerat()">
      </rask-radiobutton-group>
    </div>
    <div class="col">
      @if (arbetsorder.anskaffningsform === anskaffningsformer.Egenskog) {
        <rask-button
          aid="returnToGiss"
          class="d-inline-block pt-2"
          color="secondary"
          [disabled]="!canReturnAtgardToGiss()"
        (click)="returnAtgardToGissPopup()">Skicka i retur till GISS</rask-button>
      }
    </div>
  </div>
}
@if (arbetsorder.isGrotskotning) {
  <div class="row">
    <div class="col-4">
      <rask-button class="d-inline-block pt-2" color="secondary" (click)="removeAtgard()"
      [disabled]="!canMakuleraAtgard()" negative>Ta bort</rask-button>
    </div>
  </div>
}
@if (atgard.villkorligaDatum.length > 0) {
  <div class="row mt-2">
    <div class="col-12">
      <rask-div-list [data]="atgard.villkorligaDatum" [rowDrag]="false">
        <rask-list-column header="Villkor" field="villkor">
          <ng-template let-row="row">
            @if (!isBetweenDateRange(row)) {
              <span><i class="fal fa-exclamation-square warning"></i></span>
            }
            @if (isBetweenDateRange(row)) {
              <span><i class="fas fa-check-circle success"></i></span>
            }
            {{ row.villkor}}
          </ng-template>
        </rask-list-column>
        <rask-list-column header="Datumintervall" field="dates">
          <ng-template let-row="row">
            {{formatService.dateFormatRange(row.startdatum, row.slutdatum)}}
          </ng-template>
        </rask-list-column>
      </rask-div-list>
    </div>
  </div>
}